import React from 'react'
export const useAuth = (user) => {
    const [userAuth, setUserAuth] = React.useState({})
    React.useEffect(() => {
        setUserAuth(user)
    }, [])
    return userAuth
}